<template>
  <responsive-layout :background="'bg-riseup-beige'" data-ls-disabled/>
</template>

<script>

import ResponsiveLayout from '@/components/layout/ResponsiveLayout';

export default {
  name: 'LayoutDefault',
  components: { ResponsiveLayout },
};
</script>
